export var NodeDataType;
(function (NodeDataType) {
    NodeDataType["AnimationClipNodeData"] = "AnimationClipNodeData";
    NodeDataType["BlendNodeData"] = "BlendNodeData";
    NodeDataType["ApplyAdditiveNodeData"] = "ApplyAdditiveNodeData";
    NodeDataType["LayerBlendNodeData"] = "LayerBlendNodeData";
    NodeDataType["StateMachineNodeData"] = "StateMachineNodeData";
    NodeDataType["TransitionNodeData"] = "TransitionNodeData";
    NodeDataType["StateNodeData"] = "StateNodeData";
    NodeDataType["ConstFloatNodeData"] = "ConstFloatNodeData";
    NodeDataType["ConstBoolNodeData"] = "ConstBoolNodeData";
    NodeDataType["ControlParameterBoolNodeData"] = "ControlParameterBoolNodeData";
    NodeDataType["ControlParameterFloatNodeData"] = "ControlParameterFloatNodeData";
    NodeDataType["ControlParameterTriggerNodeData"] = "ControlParameterTriggerNodeData";
    NodeDataType["NotNodeData"] = "NotNodeData";
    NodeDataType["AndNodeData"] = "AndNodeData";
    NodeDataType["OrNodeData"] = "OrNodeData";
    NodeDataType["EqualNodeData"] = "EqualNodeData";
    NodeDataType["GreaterNodeData"] = "GreaterNodeData";
    NodeDataType["LessNodeData"] = "LessNodeData";
})(NodeDataType || (NodeDataType = {}));
